import React, {useEffect, useState} from 'react'
import {EditableNumberCell} from '../Televendeur/EditableNumberCell'
import TempsEcoule from '../TempsEcoule'
import {
  addCommentairePieceProposee,
  changeStatutProposee,
  deletePieceInProposee,
  updateProvenancePiece,
} from '../../../../../components/requests'
import moment from 'moment'
import {Tooltip} from 'react-tooltip'
import ActionPopper from './ActionPopper'
import {toast} from 'react-toastify'
import {useAuth} from '../../../../modules/auth'
import Select from 'react-select'
import {useFilAriane} from "../../../../contexts/FilArianeContext";

const ShopPiece = (props) => {
  const {
    showAllSelect,
    isAllSelected,
    setIsAllSelected,
    panier,
    setPanier,
    setCheckedPieces,
    statutsLocaux,
    loading,
    loadingPanier,
    nouveauPanier,
    setDataToDisplay,
    checkedPieces,
    initialPieces,
    setPiecesProposesModifiees,
    panierFiltered,
    dateAnnulationLocaux,
    setPiecesProps,
    setPieces,
    piecesInStockArr,
    setPiecesInStockArr,
    piecesInStockArrTemp,
    totalPropose,
    totalFraisPort,
    checkDisponibilite,
    validCountByDemPiece,
    statutLabels,
    fromListePiece,
    panierByStatus,
    setPanierByStatus,
    provenances,
    isLoadingProvenance,
    dataClientInfos,
    retraitDepot,
    setAssociations,
    setIsEditPanier,
    demandeId,
    setDemandeClient,
    setLibelleList
  } = props

  // Afficher les pièces du panier en fonction du bouton "Voir le panier" ou "Filtre par statut de pièce"
  const displayedPanier = fromListePiece ? panierByStatus : panier
  const [showCommentInput, setShowCommentInput] = useState<number | null>(null)
  const [showCommentSection, setShowCommentSection] = useState(false)
  const [message, setMessage] = useState<string>()
  const {currentUser} = useAuth()
  const {setSelectedPOTAriane} = useFilAriane()

  const isProfessionnel = dataClientInfos && dataClientInfos?.professionnel === false ? 10 : 20

  useEffect(() => {
    if (!panierByStatus?.length) return

    const mapById = new Map(panierByStatus.map((p) => [p.id, p]))

    setPanier((prevPanier) =>
      prevPanier.map((piece) => {
        const updatedPiece = mapById.get(piece.id) as any
        if (!updatedPiece) return piece

        const cleanedUpdate = Object.fromEntries(
          Object.entries(updatedPiece).filter(([_, value]) => value !== undefined)
        )

        return {...piece, ...cleanedUpdate}
      })
    )
  }, [panierByStatus])

  const handleSelectAll = () => {
    if (!panier) return

    if (isAllSelected) {
      setCheckedPieces([])
    } else {
      // Récupération des idPieceProposee qui sont annulée temporairement mais qui reste en statut PROPO
      const allIds = panier
        .filter((item) => {
          const checkQuantiteMax =
            validCountByDemPiece[item.idCLientDemandePiece] >= item.pieceQuantity
          return (
            item.statut === 'PROPO' &&
            statutsLocaux[item.idPiecePropose] !== 'CANCE' &&
            statutsLocaux[item.idPiecePropose] !== 'REFUS' &&
            statutsLocaux[item.idPiecePropose] !== 'ACCEP' &&
            statutsLocaux[item.idPiecePropose] !== 'BLOQU' &&
            !checkQuantiteMax
          )
        })
        .map((item) => item.idPiecePropose)
      setCheckedPieces(allIds)
    }
    setIsAllSelected(!isAllSelected)
  }

  const addPiece = (checked, idPiece: number) => {
    setCheckedPieces((prevArray) =>
      checked
        ? [...prevArray, idPiece]
        : prevArray.filter((checkedPiece) => checkedPiece !== idPiece)
    )
  }

  const modalTdProps = (item) => ({
    'data-bs-target': item?.isTypePiecePOT ? '#modalPOT' : '#modal_details_piece',
    'data-bs-toggle': 'modal',
    'data-bs-dismiss': 'modal',
    onClick: () => showDetail(item),
    className: 'text-hover-primary cursor-pointer',
  })

  const capitalizaFirstletter = (str) => {
    if (str != null) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    }
  }

  const showDetail = (piece: any) => {
    if (piece?.isTypePiecePOT) {
      const piecePOT = piece?.potObj
      const piecePOTs = {
        ...piecePOT,
        status: piece?.statut,
      }
      setSelectedPOTAriane(piecePOTs)
      setIsEditPanier(true)
    } else {
      setDataToDisplay(piece)
      setIsEditPanier(false)
    }
  }

  // // Recalcule la liste des pièces PROPO modifiées à chaque changement du panier
  // useEffect(() => {
  //   const modifiees = panier.reduce((acc: any[], piece: any) => {
  //     if (piece.statut !== 'PROPO') return acc
  //     const pieceInitiale = initialPieces.find((p) => p.id === piece.id)
  //     if (!pieceInitiale) return acc
  //     const isUpdated = verifyIfUpdated(piece, pieceInitiale)
  //     if (isUpdated) {
  //       acc.push(piece)
  //     }
  //     return acc
  //   }, [])
  //   setPiecesProposesModifiees(modifiees)
  // }, [panier]);

  // Verification si il ya eu un changement sur l'un des champs prix referentiel, taux remise, prix proposee et frais de port
  const verifyIfUpdated = (updatedPiece: any, pieceInitiale: any) => {
    const tauxRemiseInitial = pieceInitiale?.tauxRemise
    const fraisDePortInitial = pieceInitiale?.fraisDePort
    const prixReferentielInitial = pieceInitiale?.prixReferentielHt
    const prixVenteProposeeInitial = pieceInitiale?.prixVenteProposeeHt
    return (
      Number(updatedPiece?.tauxRemise) !== Number(tauxRemiseInitial) ||
      Number(updatedPiece?.fraisDePort) !== Number(fraisDePortInitial) ||
      Number(updatedPiece?.prixReferentielHt) !== Number(prixReferentielInitial) ||
      Number(updatedPiece?.prixVenteProposeeHt) !== Number(prixVenteProposeeInitial)
    )
  }

  const handleBlurTaux = (value: number, immat: string, id: number) => {
    if (value > 100) return
    const piece = panier.find((p) => p.immat === immat && p?.id === id)
    if (!piece) return

    // Normaliser le taux (0 à 100)
    let taux = value
    if (taux == null || isNaN(taux) || taux < 0) taux = 0
    if (taux > 100) taux = 100

    // pour la pièce POT , la valeur du prix de vente proposé ne doit pas être inférieur à prixAchatPot + 1
    if (piece?.isTypePiecePOT) {
      const prixAchatPot = piece?.prixAchatPot
      // Prix recalculé à partir du NOUVEAU taux tapé (et non l'ancien prixVenteProposeeHt)
      const prixCalcule = Number(
        (piece.prixReferentielHt - (piece.prixReferentielHt * taux) / 100).toFixed(2)
      )
      if (prixCalcule <= prixAchatPot + 1) {
        toast.warning('Le prix de vente proposé doit être supérieur à ' + (prixAchatPot + 1))
        updateFieldValue(piece.prixReferentiel, id)
        updateFieldTauxRemise(0, id)
        return
      }
    }
    updateFieldTauxRemise(taux, id)
  }

  const updateFieldTauxRemise = (value, pieceId) => {
    if (value > 100) return
    const prevPanier = [...displayedPanier]
    const newPan = prevPanier.map((piece) => {
      if (piece.id !== pieceId) return piece

      const tauxRemise = Number(value ?? 0)

      //prix de vente proposer recalculer
      const prixVenteProposeeHt =
        piece.prixReferentielHt - piece.prixReferentielHt * (tauxRemise / 100)
      // TVA POT toujours 20%
      const prixVenteProposeeTtc = Number(prixVenteProposeeHt * (1 + (piece?.isTypePiecePOT ? 20 : isProfessionnel) / 100))
      const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100
      //montant de la remise recalculer
      const montantRemise = Number(piece.prixReferentielHt) - Number(prixVenteProposeeHt)
      const updatedPiece = {
        ...piece,
        tauxRemise: Number(tauxRemise?.toFixed(1)),
        montantRemise: Number(montantRemise?.toFixed(2)),
        prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
        prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
      }
      if (piece.statut === 'PROPO') {
        const pieceInitiale = initialPieces.find((p) => p.id === pieceId)
        const tauxRemiseInitial = pieceInitiale?.tauxRemise
        const isUpdated = verifyIfUpdated(updatedPiece, pieceInitiale)
        if (tauxRemiseInitial !== undefined && isUpdated) {
          setPiecesProposesModifiees((prev) => {
            if (!prev.find((p) => p.id === piece.id)) {
              return [...prev, updatedPiece]
            }
            return prev.map((p) => (p.id === piece.id ? updatedPiece : p))
          })
        } else {
          setPiecesProposesModifiees((prev) => prev.filter((p) => p.id !== piece.id))
        }
      }
      return updatedPiece
    })

    if (fromListePiece) {
      setPanierByStatus(newPan)
    } else {
      setPanier(newPan)
    }

    if (panierFiltered) panierFiltered(newPan)
  }

  const updateFieldPrixRef = (value, pieceId) => {
    const prevPanier = [...displayedPanier]
    const newPan = prevPanier.map((piece) => {
      if (piece.id !== pieceId) return piece

      const prixReferentielHt = Number(value ?? 0)

      const prixVenteProposeeHt =
          prixReferentielHt - prixReferentielHt * (piece?.tauxRemise / 100)
      // TVA POT toujours 20%
      const prixVenteProposeeTtc = Number(prixVenteProposeeHt * (1 + (piece?.isTypePiecePOT ? 20 : isProfessionnel) / 100))
      const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

      const montantRemise = Math.max(prixReferentielHt - prixVenteProposeeHt, 0)
      const tauxRemise = piece?.tauxRemise


      const updatedPiece = {
        ...piece,
        prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
        montantRemise: Number(montantRemise?.toFixed(2)),
        tauxRemise: Number(tauxRemise?.toFixed(1)),
        prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
        prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
      }
      if (piece.statut === 'PROPO') {
        const pieceInitiale = initialPieces.find((p) => p.id === pieceId)
        const prixReferentielInitial = pieceInitiale?.prixReferentielHt
        const isUpdated = verifyIfUpdated(updatedPiece, pieceInitiale)
        if (prixReferentielInitial !== undefined && isUpdated) {
          setPiecesProposesModifiees((prev) => {
            if (!prev.find((p) => p.id === piece.id)) {
              return [...prev, updatedPiece]
            }
            return prev.map((p) => (p.id === piece.id ? updatedPiece : p))
          })
        } else {
          setPiecesProposesModifiees((prev) => prev.filter((p) => p.id !== piece.id))
        }
      }
      return updatedPiece
    })

    if (fromListePiece) {
      setPanierByStatus(newPan)
    } else {
      setPanier(newPan)
    }

    if (panierFiltered) panierFiltered(newPan)
  }

  const handleBlurPrixRef = (value: number, immat: string, id: number) => {
    const piece = panier.find((p) => p.immat === immat && p?.id === id)
    updateFieldPrixRef(piece.prixReferentielHt, id)
  }

  const updateFieldValue = (value, pieceId) => {
    const prevPanier = [...displayedPanier]
    const newPan = prevPanier.map((piece) => {
      if (piece.id !== pieceId) return piece

      const prixVenteProposeeHt = Number(value ?? 0)

      // TVA POT toujours 20%
      const prixVenteProposeeTtc = Number(prixVenteProposeeHt * (1 + (piece?.isTypePiecePOT ? 20 : isProfessionnel) / 100))
      const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100
      const montantRemise = Number(Math.max(piece.prixReferentielHt - prixVenteProposeeHt, 0))
      const tauxRemise = piece.prixReferentielHt > 0 ? Number((montantRemise / piece.prixReferentielHt) * 100) : 0
      const updatedPiece = {
        ...piece,
        prixVenteProposeeHt: prixVenteProposeeHt,
        prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
        montantRemise: Number(montantRemise?.toFixed(2)),
        tauxRemise: Number(tauxRemise?.toFixed(1)),
      }
      if (piece.statut === 'PROPO') {
        const pieceInitiale = initialPieces.find((p) => p.id === pieceId)
        const prixVenteProposeeInitial = pieceInitiale?.prixVenteProposeeHt
        const isUpdated = verifyIfUpdated(updatedPiece, pieceInitiale)
        if (prixVenteProposeeInitial !== undefined && isUpdated) {
          setPiecesProposesModifiees((prev) => {
            if (!prev.find((p) => p.id === piece.id)) {
              return [...prev, updatedPiece]
            }
            return prev.map((p) => (p.id === piece.id ? updatedPiece : p))
          })
        } else {
          setPiecesProposesModifiees((prev) => prev.filter((p) => p.id !== piece.id))
        }
      }
      return updatedPiece
    })

    if (fromListePiece) {
      setPanierByStatus(newPan)
    } else {
      setPanier(newPan)
    }

    if (panierFiltered) panierFiltered(newPan)
  }

  const handleBlur = (value, immat, id) => {
    const piece = panier.find((p) => p.immat === immat && p?.id === id)
    if (!piece) return

    if (piece?.isTypePiecePOT) {
      const prixAchatPot = piece?.prixAchatPot
      if (value == null || value <= prixAchatPot + 1) {
        toast.warning('Veuillez saisir un prix supérieur à ' + (prixAchatPot + 1))
        updateFieldValue(piece.prixReferentiel, id)
        return
      }
    }
    updateFieldValue(value, id)
  }

  const handleBlurFraisDePort = (value: number, immat: string, id: number) => {
    if (value >= 0) return
    const piece = panier.find((p) => p.immat === immat && p?.id === id)
    updateFraisValue(piece.fraisDePort, id)
  }

  const updateFraisValue = (value, pieceId) => {
    const prevPanier = [...displayedPanier]
    const newPan = prevPanier.map((piece) => {
      if (piece.id !== pieceId) return piece
      const fraisDePort = Number(value ?? 0)
      const updatedPiece = {
        ...piece,
        fraisDePort: Number(fraisDePort?.toFixed(2)),
      }
      if (piece.statut === 'PROPO') {
        const pieceInitiale = initialPieces.find((p) => p.id === pieceId)
        const fraisDePortInitial = pieceInitiale?.fraisDePort
        const isUpdated = verifyIfUpdated(updatedPiece, pieceInitiale)
        if (fraisDePortInitial !== undefined && isUpdated) {
          setPiecesProposesModifiees((prev) => {
            if (!prev.find((p) => p.id === piece.id)) {
              return [...prev, updatedPiece]
            }
            return prev.map((p) => (p.id === piece.id ? updatedPiece : p))
          })
        } else {
          setPiecesProposesModifiees((prev) => prev.filter((p) => p.id !== piece.id))
        }
      }
      return updatedPiece
    })

    if (fromListePiece) {
      setPanierByStatus(newPan)
    } else {
      setPanier(newPan)
    }

    if (panierFiltered) panierFiltered(newPan)
  }

  const statutColors: Record<string, string> = {
    A_PROPO: 'badge-light-dark',
    PROPO: 'badge-light-info',
    ACCEP: 'badge-light-primary',
    REFUS: 'badge badge-light-danger',
    BLOQU: 'badge-light-warning',
    CANCE: 'badge-light',
    ECHEC: 'badge-light-warning-echec'
  }

  const removeProposition = (idPieceProp: number) => {
    deletePieceInProposee(idPieceProp)
      // actualiser status apre delet propos dans panier
      .then(() => {
        setPiecesProps((prevPieces) =>
          prevPieces.map((p) => ({
            ...p,
            clientDemandePieceProposee: p.clientDemandePieceProposee?.filter(
              (prop) => prop.id !== idPieceProp
            ),
            typePiecePOT: [],
          }))
        )
        setPieces((prevPieces) =>
          prevPieces.map((p) => ({
            ...p,
            clientDemandePieceProposee: p.clientDemandePieceProposee?.filter(
              (prop) => prop.id !== idPieceProp
            ),
            typePiecePOT: [],
          }))
        )
        if (setLibelleList) {
          setLibelleList(
            (prev) => prev
              .filter((item) => item?.clientDemandePieceProposee?.id !== idPieceProp)
          )
        }
      })
      .catch((err) => {
        console.error('Erreur lors de la suppression de la proposition', err)
      })
    if (piecesInStockArr !== undefined && setPiecesInStockArr !== undefined) {
      setPiecesInStockArr((prev) =>
        prev.map((p) => {
          const pieceTempsValue = piecesInStockArrTemp.find(
            (item) => p?.piece_entre?.id === item?.typePieceId
          )
          return p?.id === idPieceProp
            ? {
                ...p,
                proposeePar: pieceTempsValue?.proposeePar ? pieceTempsValue?.proposeePar : null,
                proposeeA: pieceTempsValue?.proposeeA ? pieceTempsValue?.proposeeA : null,
              }
            : p
        })
      )
    }
  }

  const handlePanier = (idPiece: number, idPieceProposee: number | null) => {
    const prevPanier = [...panier]

    const newPan = prevPanier.filter((item) => {
      if (!item.isTypePiecePOT) {
        return item.id != idPiece
      } else {
        return item.idPiecePropose != idPieceProposee
      }
    })
    setAssociations({})
    setPanier(newPan)
    if (panierFiltered) panierFiltered(newPan)
    if (idPieceProposee) removeProposition(idPieceProposee)
  }

  const handleChangeStatutPropo = (idPieceProposee) => {

    const idToastChangeStatut = toast.loading('Changement de statut en cours...')
    changeStatutProposee(idPieceProposee, demandeId , panier).then((res) => {
      if (res.data) {
        //mise à jour du statut de la demande:
        setDemandeClient(res.data?.clientDemande)
        const clientDemandePieceProposee = res.data?.clientDemandePieceProposee

        //mise à jour du statut dans le panier:
        setPanier((prevPanier: any[]) => {
          return prevPanier.map((item) => {
            if (item.idPiecePropose === clientDemandePieceProposee?.id) {
              return {
                ...item,
                statut: 'A_PROPO',
              }
            }
            return item
          })
        })

        toast.update(idToastChangeStatut, {
          render: 'Changement de statut réussi',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })
      } else {
        toast.update(idToastChangeStatut, {
          render: "Erreur lors du changement de statut",
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      }
    })

  }

  // Ouverture & Fermeture section commentaire par pièce
  const handleWriteComment = (id: number) => {
    setShowCommentInput((prev) => (prev === id ? null : id))
    setShowCommentSection(false)
  }

  // Ajout de commentaire par pièce proposée
  const handleAddComment = (idPieceProposee: number) => {
    if (!message) return
    setShowCommentInput(0)
    const idAuthor = currentUser?.id
    const idToastAddComment = toast.loading('Ajout de commentaire en cours...')
    addCommentairePieceProposee(idPieceProposee, message, idAuthor).then((res) => {
      if (res.data) {
        toast.update(idToastAddComment, {
          render: 'Commentaire ajouté à la pièce',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })
      } else {
        toast.update(idToastAddComment, {
          render: "Erreur lors de l'ajout de commentaire",
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      }
    })
  }

  // Màj de provenance pour la pièce concernée
  const handleProvenanceUpdate = (idPieceProposee, idProvenance) => {
    updateProvenancePiece(idPieceProposee, idProvenance).then((res) => {
      if (res.status !== 200) {
        console.error('Erreur lors de la changement de provenance')
      }
    })
    const provenanceObj = provenances.find((prov) => prov.value === idProvenance)
    // transformer label en libellé pour l'afficher temporairement dans le panier'
    const transformedProvenanceData = {
      value: provenanceObj?.value,
      libelle: provenanceObj?.label,
    }

    setPanier((prevPanier: any[]) => {
      return prevPanier.map((item) => {
        if (item.idPiecePropose === idPieceProposee) {
          return {
            ...item,
            provenance: transformedProvenanceData,
          }
        }
        return item
      })
    })
  }

  return (
    <div>
      <div className='table-responsive'>
        <table
          className='table align-middle text-center table-row-dashed table-row-gray-300 gy-7'
          style={{fontSize: '13.5px'}}
        >
          <thead>
            <tr className='fw-bolder text-gray-800'>
              <th>
                {showAllSelect && (
                  <input
                    type={'checkbox'}
                    className={'form-check-input'}
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                  />
                )}
              </th>
              {/*<th className='min-w-100px'>Code pièce</th>*/}
              <th className='w-200px'>Pièce</th>
              <th className='min-w-180px'>Véhicule</th>
              <th className='min-w-160px text-nowrap'>Réf const</th>
              <th className='min-w-100px text-nowrap'>Prix initial (HT)</th>
              <th className='min-w-100px text-nowrap'>Etat</th>
              <th className='min-w-80px text-nowrap'>
                <span
                  data-tooltip-id='panier-header'
                  data-tooltip-place='top'
                  data-tooltip-content='Prix Referentiel (HT)'
                >
                  Prix (HT)
                </span>
              </th>
              <th className='min-w-110px text-nowrap'>Taux remise (%)</th>
              <th className='min-w-110px text-nowrap'>
                <span
                  data-tooltip-id='panier-header'
                  data-tooltip-place='top'
                  data-tooltip-content='Montant remise'
                >
                  Remise
                </span>
              </th>
              <th className='min-w-100px text-nowrap'>
                <span
                  data-tooltip-id='panier-header'
                  data-tooltip-place='top'
                  data-tooltip-content='Prix proposé (HT)'
                >
                  Prix prop. (HT)
                </span>
              </th>
              <th className='min-w-60px text-nowrap'>Frais de port (HT)</th>
              <th className='min-w-220px'>Provenance</th>
              <th className='min-w-125px'>Statut</th>
              <th className='min-w-80px'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading || loadingPanier ? (
              <tr>
                <td colSpan={14} className='pt-10 pb-0 text-center'>
                  <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
                </td>
              </tr>
            ) : nouveauPanier?.length > 0 ? (
              <>
                {displayedPanier?.map((piece: any, index: number) => {
                  const statut = statutsLocaux[piece.idPiecePropose] || piece.statut
                  const displayTimer =
                    piece?.heureDisponibilite &&
                    piece?.dateProposition &&
                    piece?.isProposed &&
                    !piece?.isDepasse &&
                    piece?.statut === 'PROPO'

                  // Désactiver le formulaire de frais de port si
                  // Le frais de port est offert
                  // Ou si retrait depot est true
                  const pieceExclue = !!dataClientInfos?.sauf?.some(
                    (item) => item.label === piece.nomTypePieceProposee
                  )
                  const fraisOffert = !!dataClientInfos?.fraisPortOffert && !pieceExclue
                  const isFraisOffertOrRetraitDepot = !!(fraisOffert || retraitDepot)

                  let backgroundColor = ''
                  if (piece.isTypePiecePOT) {
                    backgroundColor = '#ecf8ff'
                  }else if(piece.isDemontage && piece.idPieceEntre === null){
                    backgroundColor = 'rgb(230, 255, 237)'
                  }

                  return (
                    <React.Fragment key={piece.idPiecePropose ?? index}>
                      <tr style={{backgroundColor: backgroundColor}}>
                        <td>
                          {piece?.statut === 'PROPO' &&
                            statut === 'PROPO' &&
                            piece?.isProposed &&
                            !piece?.isQuantityReached && (
                              <input
                                type='checkbox'
                                className='form-check-input'
                                onChange={(e) => addPiece(e.target.checked, piece.idPiecePropose)}
                                checked={checkedPieces.includes(piece.idPiecePropose)}
                              />
                            )}
                        </td>
                        <td {...modalTdProps(piece)}>
                          <div className='d-flex justify-content-start flex-column'>
                            <span>{piece.nomTypePieceProposee}</span>
                            {piece.isTypePiecePOT && <span>[POT]</span>}
                            {(piece.isDemontage && piece.idPieceEntre === null) && <span>[Démontage parc]</span>}
                            <span className='text-muted fw-semibold text-muted d-block fs-7'>
                              {piece.codePieceEntree}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div className='d-flex justify-content-start flex-column'>
                            <span>{piece.marquePiece}</span>
                            <span className='text-muted fw-semibold text-muted d-block fs-7'>
                              {piece.modelePiece}
                            </span>
                          </div>
                        </td>
                        <td>{piece.refConstructeur}</td>
                        <td>{piece.prixReferentielHtInitial ?? 0}</td>
                        <td>{capitalizaFirstletter(piece.etat)}</td>
                        <td className='text-end'>
                          <EditableNumberCell
                            index={index}
                            className={'w-100px'}
                            piece={piece}
                            fieldName='prixReferentielHt'
                            placeholder='Prix ref'
                            min={1}
                            onChangeValue={updateFieldPrixRef}
                            onBlurValue={handleBlurPrixRef}
                            statutLocaux={statutsLocaux[piece.idPiecePropose]}
                          />
                        </td>
                        <td className='text-end'>
                          <EditableNumberCell
                            index={index}
                            className={'w-90px'}
                            piece={piece}
                            fieldName='tauxRemise'
                            placeholder='Taux remise'
                            min={0}
                            onChangeValue={updateFieldTauxRemise}
                            onBlurValue={handleBlurTaux}
                            statutLocaux={statutsLocaux[piece.idPiecePropose]}
                            disabled={piece.isTypePiecePOT}
                          />
                        </td>
                        <td className='text-center'>{piece.montantRemise ?? 0}</td>
                        <td className='text-end'>
                          <EditableNumberCell
                            index={index}
                            className={'w-100px'}
                            piece={piece}
                            fieldName='prixVenteProposeeHt'
                            placeholder='Prix de vente proposé'
                            min={1}
                            onChangeValue={updateFieldValue}
                            onBlurValue={handleBlur}
                            statutLocaux={statutsLocaux[piece.idPiecePropose]}
                          />
                        </td>

                        <td className='text-end'>
                          <EditableNumberCell
                            index={index}
                            className={'w-90px'}
                            piece={piece}
                            fieldName='fraisDePort'
                            placeholder='Frais de port'
                            min={0}
                            onChangeValue={updateFraisValue}
                            onBlurValue={handleBlurFraisDePort}
                            statutLocaux={statutsLocaux[piece.idPiecePropose]}
                            disabled={isFraisOffertOrRetraitDepot}
                          />
                        </td>
                        <td>
                          <Select
                            className='react-select-styled react-select-solid react-select-lg'
                            classNamePrefix='react-select'
                            options={provenances}
                            fieldName='provenance_piece'
                            value={provenances?.find((p) => p.label === piece?.provenance?.libelle)}
                            onChange={(e) => handleProvenanceUpdate(piece?.idPiecePropose, e.value)}
                            placeholder='Provenance'
                            isDisabled={!(piece?.statut == 'A_PROPO' || piece?.statut == 'PROPO')}
                            // Ajout de z-index pour afficher le sélécteur sans overflow
                            menuPortalTarget={document.body}
                            menuPosition='fixed'
                            styles={{
                              menuPortal: (base) => ({...base, zIndex: 9999}),
                              container: (base) => ({...base, width: '250px'}),
                            }}
                            isLoading={isLoadingProvenance}
                          />
                        </td>
                        <td>
                          <span className={`badge ${statutColors[statut] || 'badge-light'} my-1`}>
                            {statutLabels[statut] || 'Statut inconnu'}
                          </span>
                          {(() => {
                            const statutEffectif =
                              statutsLocaux[piece.idPiecePropose] ?? piece?.statut

                            let dateRaw: string | undefined

                            if (statutEffectif === 'CANCE') {
                              dateRaw =
                                dateAnnulationLocaux[piece.idPiecePropose] || piece?.dateAnnulation
                            } else if (statutEffectif === 'PROPO') {
                              dateRaw = piece?.dateProposition
                            }

                            if (!dateRaw) return null

                            const date = new Date(dateRaw)
                            const formattedDate = date.toLocaleDateString('fr-FR', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                            })
                            const formattedTime = date.toLocaleTimeString('fr-FR', {
                              hour: '2-digit',
                              minute: '2-digit',
                              timeZone: 'Europe/Paris',
                            })

                            return (
                              <>
                                <br />
                                <span style={{fontSize: '10px'}}>
                                  Le {formattedDate} à {formattedTime}
                                </span>
                              </>
                            )
                          })()}
                        </td>
                        <td>
                          <div
                            className={`d-flex gap-2 align-items-center ${
                              !displayTimer && 'justify-content-between'
                            }`}
                          >
                            <div className={'d-flex flex-column justify-content-center'}>
                              {displayTimer ? (
                                <TempsEcoule
                                  date={moment()}
                                  dateMax={moment(piece?.dateProposition).add(
                                    piece?.heureDisponibilite,
                                    'hours'
                                  )}
                                  increment={false}
                                  onChange={(temps) => {
                                    if (temps === '00:00:00') {
                                      checkDisponibilite()
                                    }
                                  }}
                                />
                              ) : null}
                              <div
                                className={'d-flex justify-content-evenly'}
                                style={{width: !displayTimer ? '75px' : undefined}}
                              >
                                {(statutsLocaux[piece?.idPiecePropose] == null ||
                                  statutsLocaux[piece?.idPiecePropose] == undefined) &&
                                  piece?.statut === 'PROPO' &&
                                  piece?.isDepasse &&
                                  piece?.dateProposition !== null && (
                                    <i
                                      className='bi bi-hourglass-bottom text-danger fs-3 p-1'
                                      data-tooltip-id='panier-header'
                                      data-tooltip-content='Proposition expirée'
                                      data-tooltip-place='top'
                                    ></i>
                                  )}

                                {piece?.isFree === 0 && (
                                  <i
                                    className='bi bi-exclamation-circle text-danger fs-3 p-1'
                                    data-tooltip-id='panier-header'
                                    data-tooltip-content={`Pièce indisponible`}
                                    data-tooltip-place='top'
                                  ></i>
                                )}
                              </div>
                            </div>
                            {/*Bouton Flottant Autres actions*/}
                            <ActionPopper
                              piece={piece}
                              index={piece?.idPiecePropose}
                              showCommentInput={showCommentInput}
                              handleWriteComment={handleWriteComment}
                              checkDisponibilite={checkDisponibilite}
                              setShowCommentSection={setShowCommentSection}
                              showCommentSection={showCommentSection}
                              handlePanier={handlePanier}
                              fromSuggestionPage={false}
                              handleChangeStatutPropo={handleChangeStatutPropo}
                            />
                          </div>
                        </td>
                      </tr>
                      {/* Ligne commentaire par pièce */}
                      {showCommentInput === piece?.idPiecePropose && (
                        <tr>
                          <td colSpan={12}>
                            <input
                              type={'text'}
                              className='form-control'
                              placeholder='Écrire un commentaire pour cette pièce...'
                              onChange={(e) => setMessage(e.target.value)}
                            />
                          </td>
                          <td>
                            <button
                              className={'btn btn-sm btn-light-primary'}
                              type={'button'}
                              onClick={() => handleAddComment(piece.idPiecePropose)}
                            >
                              Enregistrer
                            </button>
                          </td>
                          <td>
                            <button
                              className={'btn btn-sm btn-light-info'}
                              type={'button'}
                              onClick={() => setShowCommentInput(0)}
                            >
                              Annuler
                            </button>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  )
                })}

                <tr>
                  <td colSpan={14} className='text-center'>
                    <div className='d-flex justify-content-center align-items-center gap-6 fw-semibold'>
                      <span>
                        Total proposé : <span className='fs-3 mx-3'>{totalPropose} €</span>
                      </span>
                      <span>
                        Total frais de port (HT) :{' '}
                        <span className='fs-3 mx-3'>{totalFraisPort} €</span>
                      </span>
                    </div>
                  </td>
                </tr>
              </>
            ) : (
              <tr>
                <td colSpan={14} className='text-center'>
                  <div>(Panier vide pour le moment)</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Tooltip id='panier-header' style={{backgroundColor: 'black', color: 'white'}} />
      </div>
    </div>
  )
}

export default ShopPiece
